import { useState, useEffect, useRef } from 'react';

const AnimatedNumber = ({ end, duration = 1500 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const rafRef = useRef(null);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    const currentRef = ref.current;
    
    const startAnimation = () => {
      if (hasAnimatedRef.current) return;
      hasAnimatedRef.current = true;
      
      const startTime = performance.now();
      const endValue = parseFloat(end);
      const isDecimal = !Number.isInteger(endValue);

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const value = easeOut * endValue;

        setCount(isDecimal ? parseFloat(value.toFixed(1)) : Math.floor(value));

        if (progress < 1) {
          rafRef.current = requestAnimationFrame(animate);
        }
      };

      rafRef.current = requestAnimationFrame(animate);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startAnimation();
        }
      },
      { threshold: 0.3 }
    );

    if (currentRef) observer.observe(currentRef);

    // Start animation immediately if already visible
    setTimeout(() => {
      if (currentRef && !hasAnimatedRef.current) {
        const rect = currentRef.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          startAnimation();
        }
      }
    }, 100);

    return () => {
      observer.disconnect();
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [end, duration]);

  return <span ref={ref}>{count}</span>;
};

const StatsTicker = () => {
  return (
    <section className="w-full border-y border-white/5 bg-black/40">
      <div className="mx-auto flex max-w-7xl justify-center gap-6 sm:gap-10 md:gap-20 lg:gap-28 px-4 sm:px-6 py-5 sm:py-6 font-mono text-xs sm:text-sm flex-wrap">
        
        <div className="flex items-center gap-3 sm:gap-4">
          <span className="text-primary font-bold">
            <AnimatedNumber end={100} />+
          </span>
          <span className="text-white/60">Images Generated</span>
        </div>
        
        <div className="flex items-center gap-3 sm:gap-4">
          <span className="text-primary font-bold">
            <AnimatedNumber end={50} />+
          </span>
          <span className="text-white/60">Active Creators</span>
        </div>
        
        <div className="hidden sm:flex items-center gap-3 sm:gap-4">
          <span className="text-primary font-bold">
            &lt;<AnimatedNumber end={1.5} />s
          </span>
          <span className="text-white/60">Render Speed</span>
        </div>
        
        <div className="hidden md:flex items-center gap-3 sm:gap-4">
          <span className="text-primary font-bold">
            <AnimatedNumber end={99.9} />%
          </span>
          <span className="text-white/60">Uptime</span>
        </div>
        
      </div>
    </section>
  );
};

export default StatsTicker;
